import { cn } from '@/lib/utils';
import { ADMIN_STATUS } from '../types';

// NEW/ACT/TER account status pill (doc 07 §4.5). Unknown values render the raw string in a neutral pill.
const LABELS: Record<string, { label: string; className: string }> = {
  [ADMIN_STATUS.New]: {
    label: 'New',
    className: 'text-sky-400 border-sky-400/40 bg-sky-400/15',
  },
  [ADMIN_STATUS.Active]: {
    label: 'Active',
    className: 'text-emerald-400 border-emerald-400/40 bg-emerald-400/15',
  },
  [ADMIN_STATUS.Terminated]: {
    label: 'Terminated',
    className: 'text-muted-foreground border-border bg-muted/40',
  },
};

export function StatusBadge({ status }: { status?: string | undefined }) {
  if (!status) return <span className="text-muted-foreground">—</span>;
  const meta = LABELS[status] ?? {
    label: status,
    className: 'text-muted-foreground border-border bg-muted/40',
  };
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium',
        meta.className,
      )}
    >
      {meta.label}
    </span>
  );
}
